export const Colors = {
  black: '#000000',
  white: '#FFFFFF',
  extraLightGray: '#EDEFF6',
  lightGray: '#EBEDF2',
  midLightGray: '#A1A1A1',
  midGray: '#848484',
  midDarkGray: '#817A73',
  darkGray: '#373737',
  extraDarkGray: '#231F20',

  secondaryGray: '#A8A8A8',
  snackbarGray: '#BAB7B7',
  tableHeadingGray: '#B4B4C2',
  cellNonEditableGray: '#585858',
  fieldSelectionGrayBlue: '#475361',
  megaHeadingExtraDarkBlue: '#181C32',
  cardGray: '#EDEFF6',
  timelineGray: '#979797',
  orderDetailsTitle: '#585656',
  loadingOverlay: '#0000004D',

  informativeYellow: '#FFC700',
  burntOrange: '#544201',
  bookedScannedInProgressGray: '#787878',
  deliveredBlue: '#2070C7',
  overdueOrange: '#E57401',
  collectedGreen: '#34AEA7',
  retrievalRequiredPurple: '#8F49C1',
  retrievedPurple: '#6A3391',
  cancelledDeletedRed: '#DB2E2D'
};
